import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import "../styles/privacyPolicy.scss";
import { useDispatch } from "react-redux";
import { initAppBrowser } from "@actions/initApp";

const PrivacyPolicy = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(initAppBrowser(["messages"]));
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="mar-t-190 main-container-page-width">
      <Helmet title={`Privacy Policy | CardCash`} />

      <div>
        <h1> Privacy Policy </h1>
        <p>
          This privacy policy has been compiled to better serve those who are
          concerned with how their 'Personally identifiable information' (PII)
          is being used online. PII, as used in US privacy law and information
          security, is information that can be used on its own or with other
          information to identify, contact, or locate a single person, or to
          identify an individual in context.
        </p>
        <p>
          Please read our privacy policy carefully to get a clear understanding
          of how we collect, use, protect or otherwise handle your Personally
          Identifiable Information in accordance with our systems. By using our
          sites, app or other systems, you are agreeing to this Privacy Policy.
        </p>
        <div className="mar-t-50">
          <b>Data Collection</b>
          <div>
            <p>
              We collect information from you when you register on our site,
              place an order, subscribe to a newsletter, respond to a survey,
              fill out a form, enter information on our site or otherwise
              interact with our services. The information we collect is used to
              process orders, detect and prevent fraud, track trends and better
              understand how users interact with our services.
            </p>
            <p>
              Information automatically collected when you browse or use our
              Site includes but is not limited to: device type, browser,
              operating system, IP address, Device geolocation, device ID,
              internet service provider, the search engine used, referring
              sites, social media accounts that may be linked to you, and the
              websites you have accessed before, during and immediately after
              visiting or using our services.
            </p>
            <p>
              We can also ask you to provide additional information including:
            </p>
            <ul>
              <li>
                Contact information, such as name, email address, mailing
                billing and shipping addresses, fax or phone number
              </li>
              <li>
                Payment and financial information, such as credit or other
                payment card information, and bank account information.
              </li>
              <li>Social Security Number, tax ID or EIN number</li>
              <li>
                Unique identifiers such as user name, account number, or
                password; and,
              </li>
              <li>
                Preference information such as product wish lists, order
                history, or marketing preferences.
              </li>
              <li>
                Information about your business such as company name, company
                size, or business type.
              </li>
              <li>
                Demographic information, such as age, gender, interests and ZIP
                code;
              </li>
            </ul>
            <p>
              We may also combine the information you provide with information
              from third-party sources. For example, we may confirm your address
              with the postal service or verify your personal information with a
              credit-reporting agency or other fraud prevention methods or
              services. We will treat the combined information in accordance
              with the terms of this Policy.
            </p>
            <p>
              We use "cookies" that collect non personal information for
              internal uses as described above. You have the option to delete
              and decline in your cookie setting, but please note that this may
              prevent you from using some features of our service.
            </p>
          </div>
        </div>
        <div className="mar-t-50">
          <b>Protecting your information</b>
          <div style={{ fontSize: "14px" }}>
            <p>
              Our website, servers and systems are scanned on a regular basis
              for security holes and known vulnerabilities in order to make your
              visit to our site as safe as possible.
            </p>
            <p>
              Your personal information is contained behind secured networks. We
              use encryption and other accepted industry standards to secure the
              transmission of data. All credit card transactions are processed
              through a gateway provider and are not stored or processed on our
              servers.
            </p>
          </div>
        </div>
        <div className="mar-t-50">
          <b>Request removal of your information</b>
          <div>
            <p>
              To have your data removed please contact us at
              support@cardcash.com.
            </p>
            <p>
              To unsubscribe from our marketing email list please click on the
              unsubscribe link in any of our marketing emails or contact us at
              support@cardcash.com.
            </p>
          </div>
        </div>
        <div className="mar-t-50">
          <b>Third-party disclosure</b>
          <div>
            <p>
              We will not share Personal Information with third parties without
              your permission, except for the Permitted Purposes, as defined
              below. We may, however, use any information we have gathered from
              or about you, including but not limited to Personal Information,
              for our own internal business purposes, such as determining ways
              and methods of improving our services and Products.
            </p>
            <p>"Permitted Purposes" shall mean any of the following:</p>
            <ul>
              <li>
                Complying with applicable laws and law enforcement requests,
                with regulatory authorities, courts, and governmental agencies
                to comply with legal orders, legal or regulatory requirements,
                and government requests;
              </li>
              <li>
                In order to take action regarding illegal activities or
                suspected fraud or other abuses of our services.
              </li>
              <li>Investigating any disputed charges.</li>
              <li>
                Fulfilling your product or service request and providing you
                with a business or technical support function.
              </li>
              <li>Various methods of fraud detection and prevention.</li>
              <li>
                Hosting, developing, and maintaining our service, our database,
                and enhancing our network information.
              </li>
              <li>
                Creating and publishing reports on trend and patterns for
                business-related practices.
              </li>
              <li>
                Satisfying requirements for promotions and sweepstakes in which
                you have participated.
              </li>
              <li>
                The transfer of our assets in the event of sale, merger,
                acquisition by another company, or the sale of all or a portion
                of our assets. We may disclose or sell such information as an
                asset of the company in conjunction with the sale to a third
                party of our company or portion of our assets.
              </li>
            </ul>
            <p>
              We do not sell, trade, or otherwise transfer to outside parties
              your personally identifiable information unless we provide users
              with advance notice. This does not include website hosting
              partners and other parties who assist us in operating our website,
              conducting our business, or serving our users, so long as those
              parties agree to keep this information confidential. We may also
              release information when it's release is appropriate to comply
              with the law, enforce our site policies, or protect ours or
              others' rights, property or safety.
            </p>
            <p>
              However, non-personally identifiable visitor information may be
              provided to other parties for marketing, advertising, or other
              uses.
            </p>
          </div>
        </div>
        <div className="mar-t-50">
          <b>Google</b>
          <div>
            <p>
              We use Google Analytics on our website. Google uses DART cookies
              to enable it to serve ads to our users based on previous visits to
              our site and other sites on the Internet as well as provides us
              with demographics and interests reporting. You can set preferences
              for how Google advertises to you using the Google Ad Settings
              page. Alternatively, you can opt out by visiting the Network
              Advertising initiative opt out page or permanently using the
              Google Analytics Opt Out Browser add on.
            </p>
          </div>
          <div className="mar-t-50">
            <b>Protecting Children's Online Privacy</b>
            <div>
              <p>
                We do not specifically market to children under 13. And request
                that such minors do not share personal information on our site.
              </p>
            </div>
          </div>
          <div className="mar-t-50">
            <b>Policy Changes</b>
            <div>
              <p>
                We will from time to time update, modify or amend our Privacy
                Policy with information that is necessary. It is your sole
                responsibility to fully read and understand our policy and all
                updates, modifications, and amendments. If we make any changes
                to our Privacy Policy, we will notify you either by amending
                this Agreement.
              </p>
            </div>
            <div className="mar-t-50"></div>
            <b>Third-party links</b>
            <p>
              We do not include or offer third-party products or services on our
              website. However we may provide links that can take you to other
              websites that may be useful for you.
            </p>
          </div>
          <div className="mar-t-50"></div>
          <b>Contacting Us</b>
          <p>
            If there are any questions regarding this privacy policy you may
            contact us:
          </p>
          <p>
            cardcash.com
            <br />
            990 Cedarbridge Avenue
            <br />
            Brick, New Jersey 08723
            <br />
            United States
            <br />
          </p>
        </div>
        <hr />
        <br />
        <h2>Your California Privacy Rights</h2>
        <br />
        <br />
        <b>California Consumer Privacy Act</b>
        <p>
          If you are a California resident, the information below also applies
          to you. Certain terms used in this section have the meanings given to
          them in the California Consumer Privacy Act of 2018 (“CCPA”).
        </p>
        <b>California Privacy Rights</b>
        <p>
          California law permits customers in California to request certain
          details about how their “personal information” (as defined by
          California Civil Code Section 1798.83) is shared with third parties
          for direct marketing purposes. Under the law, a business must either
          provide this information or permit California customers to opt in to,
          or opt out of, this type of sharing.
        </p>
        <b>Links to other sites</b>
        <p>
          CardCash Services may include links to other websites for your
          convenience and information. Websites that are operated by entities
          not affiliated with CardCash may have their own privacy policies or
          notices, which we strongly suggest you review. CardCash is not
          responsible for the content or privacy practices of any linked
          websites that we do not control.
        </p>
        <b>
          Categories of Personal Information CardCash has collected from or
          about its Guests in the preceding 12 months
        </b>
        <p>
          <ul>
            <li>
              Identifiers (e.g. name, mailing address, email address, phone
              number, credit/debit card number)
            </li>
            <li>
              Characteristics of protected classifications (e.g. gender, age)
            </li>
            <li>
              Commercial information (e.g. products or services purchased,
              purchase history)
            </li>
            <li>
              Internet or other electronic network activity (e.g. browse or
              search history)
            </li>
            <li>Geolocation data (e.g. latitude or longitude)</li>
            <li>
              Audio, electronic, visual, or similar information (e.g. recording
              of Guest service calls)
            </li>
            <li>
              Inferences drawn from any of the above (e.g. preferences or
              characteristics)
            </li>
          </ul>
        </p>
        <b>
          Categories of Sources from which CardCash has Collected Personal
          Information about Guests
        </b>
        <p>
          <ul>
            <li>
              Performing services, including maintaining or servicing accounts,
              providing customer service, processing or fulfilling orders and
              transactions, verifying customer information, processing payments,
              providing advertising or marketing services, providing analytics
              services, or providing similar services;
            </li>
            <li>
              Auditing related to a current interaction with you and concurrent
              transactions, including, but not limited to, counting ad
              impressions to unique visitors, verifying positioning and quality
              of ad impressions, and auditing compliance;
            </li>
            <li>
              Short-term, transient use, including, but not limited to, the
              contextual customization of ads shown as part of the same
              interaction;
            </li>
            <li>
              Detecting security incidents, protecting against malicious,
              deceptive, fraudulent, or illegal activity that violates our Terms
              of Use and prosecuting those responsible for that activity;
            </li>
            <li>
              Debugging to identify and repair errors that impair existing
              intended functionality;
            </li>
            <li>
              Undertaking internal research for technological development and
              demonstration; and
            </li>
            <li>
              Undertaking activities to verify or maintain the quality or safety
              of a service or device that is owned, manufactured, manufactured
              for, or controlled by us, and to improve, upgrade, or enhance the
              service or device that is owned, manufactured, manufactured for,
              or controlled by us...
            </li>
          </ul>
        </p>
        <b>
          CardCash may use the information collected for various purposes,
          including to
        </b>
        <p>
          <ul>
            <li>Personalize and improve your online experience;</li>
            <li>
              Respond to emails or other requests, inquiries, comments, or
              questions;
            </li>
            <li>Provide customer support;</li>
            <li>
              Present you with offers tailored to your interests and past
              activities or usage of the Services;
            </li>
            <li>
              Monitor and analyze trends, usage, and activities of visitors to,
              and users of, the Services;
            </li>
            <li>
              Improve the Services, our marketing, and products or services we
              may offer;
            </li>
            <li>
              Contact you regarding your use of the Services or, in our
              discretion, changes to our policies;
            </li>
            <li>Verify and/or authenticate a user’s identity;</li>
            <li>
              Provide users with information that we believe may be useful to
              them, such as information about products or services offered by us
              or by others;
            </li>
            <li>
              Prevent fraud or other misuse of the Services, including
              protecting our rights and the rights of affiliates or related
              third parties;
            </li>
            <li>Maintain records of our transactions and communications;</li>
            <li>
              Comply with applicable laws, regulations, or legal process as well
              as industry standards and our company policies;
            </li>
            <li>
              Prevent, investigate, identify, or take any other action with
              regard to any suspected or actual fraudulent or illegal activity
              or any activity; or that violates our terms of service
            </li>
          </ul>
        </p>
        <b>How We May Share Information</b>
        <p>
          We may permit our agents, consultants, and other service providers to
          access information we collect about you through the Services to carry
          out work on our behalf. We also may use outside companies to help us
          send emails or text messages and manage email or text message
          campaigns, manage our careers page, or host or operate the Services.
          These third party service providers use the personal information to
          which they have access to carry out the purposes for which we shared
          the information.
        </p>
        <p>
          We also may share your information: (1) if we are required to do so by
          law, regulation, or legal process (such as in response to a court
          order or subpoena or similar government request for information); (2)
          to fulfill requests by government agencies, including law enforcement
          authorities; (3) when we believe disclosure is necessary or
          appropriate to prevent financial loss, or in connection with an
          investigation of suspected or actual illegal activity; (4) to enforce
          our policies, or to protect legal rights, property, or safety; (5)
          with third parties, to investigate or address possible criminal or
          fraudulent activity; or (6) in the event of a joint venture,
          partnership, merger, or other collaboration with another organization.
        </p>
        <p>
          We reserve the right to transfer any information we obtain through the
          Services in the event we sell or transfer all or a portion of our
          business or assets (e.g., further to a merger, reorganization,
          liquidation, or any other business transaction, including negotiations
          of such transactions).
        </p>
        <b>Location Information</b>
        <p>
          When you use our mobile applications, we may collect, use, and share
          precise location data about you to provide and improve our
          location-based products and services. Where available, location-based
          services may use technologies such as GPS, Bluetooth, crowd-sourced
          Wi-Fi hotspots, and cell tower locations to determine a mobile
          device's approximate location. You may use your device settings to
          restrict this type of location tracking generally, and/or to prevent a
          particular app from obtaining location data about your device in
          connection with the use of that app.
        </p>
        <b>Information Security</b>
        <p>
          We maintain appropriate administrative, technical, and physical
          safeguards designed to help protect personal information collected or
          received through the Services. Although we use reasonable efforts to
          safeguard information, transmission via the Internet is not completely
          secure and we cannot guarantee the security of your information
          collected through the Services.
        </p>
        <b>California Shine the Light</b>
        <p>
          <b>You Have the Following rights under the CCPA -</b>
          <ul>
            <li>
              Right to request CardCash disclose Personal Information, or
              Categories of Personal Information, it collects & uses.
            </li>
            <li>
              Right to request Cardcash delete Personal Information we have
              collected from you
            </li>
          </ul>
        </p>
        <p>
          If you are a California resident and have an established business
          relationship with CardCash, you can request a notice disclosing the
          categories of personal information we have collected/stored.
        </p>
        <p> To request a notice, please submit your request to;</p>
        <p>
          <b>
            CardCash Exchange LLC, Attn:Compliance/ California Shine the Light
            Inquiry,
          </b>
        </p>
        <p>
          <b>
            990 CedarBridge Ave STE B7, RM 365
            <br />
            Brick NJ. 08723.
          </b>
        </p>
        <p>Please allow 30 days for a response.</p>
        <p>
          Note that fulfillment of the request may not ensure complete or
          comprehensive removal
        </p>
        <br />
        Last Edited on 2022-04-26
      </div>
    </div>
  );
};

export default PrivacyPolicy;
